import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Download, Smartphone, Monitor, Play } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BASE = process.env.REACT_APP_BACKEND_URL || '';

const VIDEOS = [
  {
    id: 'android',
    label: 'Samsung Android',
    icon: Smartphone,
    color: 'from-green-600 to-green-800',
    badge: 'bg-green-100 text-green-700',
    desc: 'Tutorial passo a passo para instalar o Trabadju num Samsung com Chrome',
    file: 'trabadju_android_reels.mp4',
    filename: 'Trabadju_Tutorial_Android_Samsung.mp4',
    duration: '20s · 9:16 · Reels',
  },
  {
    id: 'ios',
    label: 'iPhone / iPad',
    icon: Monitor,
    color: 'from-blue-600 to-blue-800',
    badge: 'bg-blue-100 text-blue-700',
    desc: 'Tutorial passo a passo para instalar o Trabadju num iPhone com Safari',
    file: 'trabadju_ios_reels.mp4',
    filename: 'Trabadju_Tutorial_iPhone_iOS.mp4',
    duration: '20s · 9:16 · Reels',
  },
];

export default function AdminVideos() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-slate-50" data-testid="admin-videos-page">
      <div className="max-w-2xl mx-auto px-4 py-10">
        <div className="mb-8">
          <h1 className="text-xl font-bold text-slate-900 mb-1">Vídeos de Instalação PWA</h1>
          <p className="text-sm text-slate-500">Reels gerados com IA · 20s · 720×1280 (9:16) · Prontos para Instagram/TikTok</p>
        </div>

        <div className="space-y-5">
          {VIDEOS.map(v => {
            const Icon = v.icon;
            const src = `${BASE}/downloads/videos/${v.file}`;
            return (
              <div key={v.id} className="bg-white border border-slate-200 rounded-2xl overflow-hidden" data-testid={`video-card-${v.id}`}>
                <div className={`h-1.5 bg-gradient-to-r ${v.color}`} />
                <div className="p-5">
                  <div className="flex items-start justify-between gap-3 mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center">
                        <Icon className="h-5 w-5 text-slate-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-slate-900 text-sm">{v.label}</p>
                        <p className="text-xs text-slate-500">{v.duration}</p>
                      </div>
                    </div>
                    <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${v.badge}`}>Pronto</span>
                  </div>
                  <p className="text-sm text-slate-600 mb-4">{v.desc}</p>

                  {/* Preview player */}
                  <div className="relative bg-black rounded-xl overflow-hidden mb-4 aspect-[9/16] max-h-80 mx-auto max-w-[150px]">
                    <video
                      src={src}
                      controls
                      muted
                      playsInline
                      className="w-full h-full object-cover"
                      data-testid={`video-preview-${v.id}`}
                    />
                  </div>

                  <a
                    href={src}
                    download={v.filename}
                    data-testid={`video-download-${v.id}`}
                  >
                    <Button className="w-full bg-[#0b1e44] hover:bg-[#0b1e44]/90 gap-2">
                      <Download className="h-4 w-4" />
                      Descarregar vídeo
                    </Button>
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-8 bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-800">
          <p className="font-semibold mb-1">Como publicar no Instagram</p>
          <ol className="list-decimal list-inside space-y-1 text-xs leading-relaxed">
            <li>Descarrega o ficheiro MP4 para o telemóvel</li>
            <li>Abre o Instagram → "+" → Reel</li>
            <li>Selecciona o vídeo da galeria</li>
            <li>Adiciona música, legenda e publica</li>
          </ol>
        </div>
      </div>
    </main>
  );
}
